module.exports = __webpack_public_path__ + "static/txtling2-197x300-b98b610aaa1e638fd1645dbffa4789eb.png";